<h1 class="main sticky-top">
  <div class="row">
      <div class="col-sm-4">Token Management</div>
      <div class="col-sm-8">
        <div class="d-flex flex-row align-items-center flex-wrap float-end">
          <button *accessControl="[ApplicationRoles.EDLADMIN]" type="button" uiSref="authenticated.administration.token-add" class="btn btn-secondary">Add Token</button>
        </div>
      </div>
  </div>
</h1>
<!-- Desktop Grid -->
<table class="table table-striped d-none d-md-block">
  <caption class="visually-hidden">Token management list with token, description, groups, roles, and available actions</caption>
  <thead>
      <tr>
          <th scope="col" class="fit text-left no-wrap">
              Token
          </th>
          <th scope="col" class="fit text-left no-wrap">
              Description
          </th>
          <th scope="col" class="fit text-center no-wrap">
              Group(s)
          </th>
          <th scope="col" class="fit text-center no-wrap">
              Role(s)
          </th>
          <th scope="col" class="fit">Actions</th>
      </tr>
  </thead>
  <tbody>
      <tr *ngFor="let token of tokens?? []">
          <td class="fit center">{{token.Token}}<span *ngIf="token.IsDefault"> (Default)</span></td>
          <td class="text-break">{{token.Description}} </td>
          <td class="fit text-center">
           {{token.GroupDisplay}}

          </td>
          <td class="fit center">
            {{token.RoleDisplay}}
          </td>
          <td class="fit center no-wrap">
            <div ngbDropdown container="body">
              <button class="btn btn-info" ngbDropdownToggle>Actions</button>
              <div ngbDropdownMenu>
                <ng-template [ngIf]="!token.IsDefault">
                  <button type="button" title="Delete Token" class="dropdown-item"
                    *accessControl="[ApplicationRoles.EDLADMIN];"
                    (click)="deleteToken(token)">Delete</button>
                </ng-template>
                <a title="Edit Token" class="dropdown-item"  uiSref="authenticated.administration.token-edit"  [uiParams]="{ tokenid: token.Token }"   >
                  <span *accessControl="[ApplicationRoles.EDLADMIN]">Edit</span>
                  <span *accessControl="[ApplicationRoles.ADMIN]">View</span>
                </a>
                <ng-template [ngIf]="!token.IsDefault">
                  <button type="button" title="Set as Default" class="dropdown-item"
                    *accessControl="[ApplicationRoles.EDLADMIN];"
                    (click)="setAsDefault(token)">Set As Default</button>
                </ng-template>
              </div>
          </div>
          </td>
      </tr>
  </tbody>
</table>

